/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 */

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import SINGUP_BACKGROUND from "../../assets/img/landing_main_background.png";
import LoadingScreen from "../../components/feedback/LoadingScreen";
import { isLoading } from "../../reducers/app";

const classes = {
  root: {
    minHeight: "950px",
    background: "#DDE5EF",
    overflowX: "hidden",
    overflowY: "hidden",
    padding: 20,
    backgroundImage: `url(${SINGUP_BACKGROUND})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    fontWeight: "300",
  },
  container85: {
    width: "85%",
    margin: "0 auto",
    minHeight: "750px",
    background: "#fff",
    padding: "15px 30px",
  },
  pageTitle: {
    color: "#1f577b",
    fontSize: "1.7rem",
    fontWeight: "500",
    marginBottom: "15px",
    marginTop: "50px",
  },
  title: {
    fontWeight: "500",
    display: "block",
    marginBottom: "10px",
    marginTop: "20px",
  },
};

// interface Props {
// 	isLoading: boolean,
// 	classes: Object,
// }

const PrivacyPolicy = React.memo((/* props: Props */) => {
  //  const classes = useStyles();
  const dispatch = useDispatch();
  // const history = useHistory();

  useEffect(() => {
    // code to run on component mount
  }, [dispatch]);

  const {
    // user,
    isPageLoading,
  } = useSelector((globalState) => ({
    // user: getUserData(globalState),
    isPageLoading: isLoading(globalState),
  }));

  if (isPageLoading) {
    return <LoadingScreen />;
  }

  return (
    <div style={classes.root}>
      <Grid container sx={classes.container85}>
        <Grid item xs={12}>
          <Typography component="p">
            <Typography component="strong" sx={classes.pageTitle}>
              Terms of Use: MotCos
            </Typography>
            <Typography component="strong" sx={classes.title}>
              Portal Definitions:
            </Typography>
            <Typography component="p">
              “ESSS” means the Elmos Semiconductor Sales & Solutions GmbH, Heinrich-Hertz-Straße 1,
              44227 Dortmund, Germany.
            </Typography>
            <Typography component="p">
              “User” means you as a natural person or the legal entity on which behalf you are
              logged into the MotCoS Portal and consenting to these conditions.
            </Typography>
            <Typography component="p">
              “MotCoS Portal” means the online portal provided by ESSS and all tools, services and
              software included in it. The MotCoS Portal enables the User to simulate certain
              development and system solutions.
            </Typography>
            <Typography component="strong" sx={classes.title}>
              Terms:
            </Typography>
            <Typography component="ol" type="1">
              <Typography component="li">
                ESSS grants to User a free-of-charge usage right of the MotCoS Portal via one
                specific user account, if the registration process to the MotCoS Portal has been
                completed successfully. ESSS may decide individually if a user account will be
                activated.
              </Typography>
              <Typography component="li">
                ESSS may limit or extend the usage right of the MotCoS Portal anytime without any
                restrictions on its sole discretion.
              </Typography>
              <Typography component="li">
                In order to access the MotCoS Portal the User has to use specific login information.
              </Typography>
              <Typography component="li">
                User may not transfer any rights to the MotCoS Portal to a third party. For legal
                entities, the account is limited to one specific employee defined in the
                registration process. User may not grant access to the user account to other
                employees.
              </Typography>
              <Typography component="li">
                User may use the MotCoS Portal only for laboratory and testing purposes and must not
                use the MotCoS Portal for other purposes or within non-laboratory environments.
                Especially, the use or the integration in production systems, appliances or other
                installations is prohibited.
              </Typography>
              <Typography component="li">
                The MotCoS Portal is provided on an as-is-basis and has not been tested by ESSS. For
                avoidance of doubt, ESSS makes no representation or warranty on the availability,
                functionality, the specifications, information, accuracy, reliability or the
                characteristics of the MotCoS Portal or any results created by using the MotCoS
                Portal.
              </Typography>
              <Typography component="li">
                The MotCoS Portal is a business secret of ESSS. User may not make the MotCoS Portal
                available to third parties.
              </Typography>
              <Typography component="li">
                The User shall hold the content of the MotCoS Portal in strict confidence and use
                its best efforts to protect the MotCoS Portal from unauthorized use or disclosure to
                third parties.
              </Typography>
              <Typography component="li">
                Any liability of ESSS for financial or economic damages due to negligence of ESSS is
                excluded.
              </Typography>
              <Typography component="li">
                User and ESSS may terminate this agreement along with the usage right of the MotCoS
                Portal anytime. In this event of termination, the usage right of the MotCoS Portal
                ceases and the user account will be disabled.
              </Typography>
              <Typography component="li">
                This agreement shall be subject to German law excluding the United Nations
                Convention on Contracts for the International Sale of Goods (CISG). The parties
                submit all their disputes arising under or in connection with this agreement to the
                exclusive jurisdiction of the courts having jurisdiction in Dortmund.
              </Typography>
            </Typography>
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
});

export default PrivacyPolicy;
